import {useId} from 'react';
import './ClientInstallInstructions.css';

// "Which product is this for?" Shared by browser setup on /brief and the
// approval page local installs open, so both flows ask it the same way.
export function PlanChoice({plans,value,onChange}) {
  const id=useId();
  return <span className="pabs-plan-choice">
    <label htmlFor={id} className="pabs-install-sr-only">Which product is this for?</label>
    <select id={id} value={value} onChange={event=>onChange(event.target.value)}>
      <option value="new">A new product</option>
      {plans?.length>0 && <optgroup label="Already in Pabs">
        {plans.map(plan=><option key={plan.id} value={plan.id}>{plan.plan_name || `Plan ${plan.id}`}</option>)}
      </optgroup>}
    </select>
  </span>;
}

// What the person is agreeing to, in one sentence for both flows.
export function ConnectionScope({selection}) {
  return <>{selection==='new' ? 'It can only set up and work on this new product, never your others.' : 'It can only work on this product, never your others.'} Revoke it any time.</>;
}
